// extracted by mini-css-extract-plugin
module.exports = {"linkText":"faqLink_linkText__HhKNB","icon":"faqLink_icon__XLZad","wiggleRight":"faqLink_wiggleRight__hVIH4"};